import { createHandlerChainRunner, markSkipOnCompleteIfOnSuccessIsSet } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { QuoteEmailParameter, SendQuoteEmailResult, sendQuoteEmailService } from "@WhiteCap/Services/SendQuoteEmailService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface sendQuoteEmailApiParameter extends ApiParameter {
    quoteEmailParameter: QuoteEmailParameter;
    onSuccess?: () => void;
    onError?: (message: string) => void;
}

type HandlerType = CustomApiHandler<sendQuoteEmailApiParameter,SendQuoteEmailResult>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};
export const SendDataToApi: HandlerType = async props => {
     await sendQuoteEmailService(props.apiParameter.quoteEmailParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
     markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
};
export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];
const sendQuoteEmail = createHandlerChainRunner(chain, "SendQuoteEmail");
export default sendQuoteEmail;
